import { NavLink } from "react-router-dom";
import { useState } from "react";

const Menu = ({menu}) => {
    const [show, setShow] = useState(false);
    const handleNavClick = () => {
        setShow(false);
    };

    return (
        <>
            <button onClick={() => setShow(!show)} className="navbar-toggler">
                <span className="navbar-toggler-icon"></span>
            </button> 

            <div id="navbarSupportedContent"  className={`collapse navbar-collapse  ${show ? " show" : ""}`}>
                <ul className="navbar-nav mr-auto  px-4 px-lg-0">
                    {menu && menu.map((item) =>                
                        <li 
                            key={item.id} 
                            data-bs-toggle={item.submenu && 'dropdown'}    
                            className={`nav-item d-inline-block d-xl-flex flex-column justify-content-center align-items-center`}>
                            <NavLink 
                                onClick={handleNavClick}
                                aria-controls="basic-navbar-nav" 
                                className={item.submenu ? 'dropdown-toggle' :'null'}
                                to={item.url} 
                                title={item.name} 
                                target={item.target}
                                >
                                {item.name}
                            </NavLink>

                            {item.submenu &&
                                <ul className="dropdown-menu">
                                    {item.submenu.map(menu => 
                                        <li key={menu.id} className='dropdown-item'>
                                            <NavLink 
                                            onClick={handleNavClick}
                                                to={menu.url} 
                                                title={menu.name} 
                                                target={menu.target}
                                            >
                                                {menu.name}
                                            </NavLink>
                                        </li>                                  
                                    )}                                
                                </ul>
                            }
                        </li>
                    )}                     
                </ul>
            </div>
        </>
    );
};

export default Menu;
